module.exports = __webpack_public_path__ + "img/home-pencil.2206a342.png";